document.addEventListener('DOMContentLoaded', () => {
  UWX.Waiting('.site_title', { delayMSec: 100, activateClass: '--actived',});
  UWX.Waiting('.site_description', { delayMSec: 300, activateClass: '--actived',});
  UWX.Waiting('.js-base', { delayMSec: 400, activateClass: '--actived',});
  UWX.Waiting('.js-plane_left', { delayMSec: 500, activateClass: '--actived',});
  UWX.Waiting('.js-plane_center', { delayMSec: 600, activateClass: '--actived',});
  UWX.Waiting('.js-plane_right', { delayMSec: 700, activateClass: '--actived',});
  UWX.Waiting('.js-ppl_left', { delayMSec: 800, activateClass: '--actived',});
  UWX.Waiting('.js-ppl_center', { delayMSec: 900, activateClass: '--actived',});
  UWX.Waiting('.js-ppl_right', { delayMSec: 1000, activateClass: '--actived',});

  if(window.matchMedia('(max-width: 768px)').matches){
    setSwiperCase()
  }
});

const setSwiperCase = () => {
  return new Swiper('.js-slider-case', {
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides : true,
    autoplay: {
      delay: 5000,
    },
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
